import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

import { useGetPlacementCandidate } from "../../../PlacementCandidate/api/useGetPlacementCandidate";
import { isPlacementCandidate } from "../../../PlacementCandidate/types";
import { usePayTransparency } from "../PlacementDetailsPage/hooks/usePayTransparency";
import { PayDetailsStep } from "./PayDetailsStep";
import { usePlacementDetails } from "./PlacementDetailsContext";

interface PayDetailsStepContainerProps {
  applicationQualification: string | undefined;
}

export function PayDetailsStepContainer(props: PayDetailsStepContainerProps) {
  const { applicationQualification } = props;
  const placementDetails = usePlacementDetails();

  const worker = useDefinedWorker();

  const { data: placementCandidate } = useGetPlacementCandidate(
    { workerId: worker.userId },
    { enabled: Boolean(worker.userId) }
  );

  const { isPayTransparencyAvailable, transparencyPayRates, highestMatchingQualification } =
    usePayTransparency(placementDetails);

  if (!isPlacementCandidate(placementCandidate) || !isPayTransparencyAvailable) {
    return null;
  }

  return (
    <PayDetailsStep
      placementForComputedPay={{
        id: placementDetails.id,
        workplaceId: placementDetails.workplace.id,
        workerTypes: placementDetails.workerTypes,
        jobShifts: placementDetails.jobShifts,
        transparencyPayRates: placementDetails.transparencyPayRates,
        attributes: { payRange: placementDetails.payRange },
      }}
      placementCandidate={placementCandidate}
      transparencyPayRates={transparencyPayRates}
      applicationQualification={applicationQualification}
      highestMatchingQualification={highestMatchingQualification}
      workerId={worker.userId}
    />
  );
}
